import { render, staticRenderFns } from "./BaseCalendar.vue?vue&type=template&id=2ca052ae"
import script from "./BaseCalendar.vue?vue&type=script&lang=js"
export * from "./BaseCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports